import "../styles/header.css";
import Footer from "../elements/footer";
import Stomach from "../homeElements/stomach";
import { Helmet } from "react-helmet";
import HeaderCarousel from "../homeElements/headerCarousel";

function Home() {
  return (
    <div>
      <Helmet>
        <title>Maker Skills Up activities</title>
        <meta
          name="description"
          content="Joins us in maker Skills Up to explore, dream, make, create, innovate and share with the help of our equipment, kits, and Our revolutionary educational programs about modern technologies.  We welcome kids, adults, and entrepreneurs to our MakerSpace.The best way to learn is to practice."
        />
        <meta
          name="keywords"
          content="Innovation, Technologies, Maker, Invention, Create, Skills, Maker Space, Engineer"
        />
      </Helmet>
      <HeaderCarousel type={"overview"} />
      <Stomach />
      <Footer />
    </div>
  );
}
export default Home;
